'use client';

import { Chip, ChipGroup, Flex } from '@coolblue-development/freddy';
import selectUsageSituationTrigger from '@coolblue-development/ga4-events/triggers/Configurator/selectUsageSituationTrigger';
import showUsageSituationsTrigger from '@coolblue-development/ga4-events/triggers/Configurator/showUsageSituationsTrigger';
import { TrackImmediate, useAnalytics } from '@coolblue-development/next-analytics/client';

import { useConfigurator } from './ConfiguratorContext';

export default function ConfiguratorUseCases() {
  const { trackEvent } = useAnalytics();
  const {
    configurator,
    actions: { setSelectedUseCaseIndex },
    states: { selectedUseCaseIndex }
  } = useConfigurator();

  const handleChange = (value: string | string[]) => {
    setSelectedUseCaseIndex(Number(value));
    trackEvent(selectUsageSituationTrigger({ content: configurator.useCases[Number(value)].name }));
  };

  if (configurator.useCases.length < 2) {
    return null;
  }

  return (
    <>
      <TrackImmediate trigger={showUsageSituationsTrigger()} />
      <Flex mb={400}>
        <ChipGroup variant='button' onChange={handleChange} value={String(selectedUseCaseIndex)}>
          {configurator.useCases.map((useCase, index) => (
            <Chip value={String(index)} key={index}>
              {useCase.name}
            </Chip>
          ))}
        </ChipGroup>
      </Flex>
    </>
  );
}
